export default {"src":"/_next/static/media/brand-selected-location.89137966.svg","height":13,"width":9,"blurWidth":0,"blurHeight":0};